import { render, staticRenderFns } from "./LinkList.vue?vue&type=template&id=4f435de0&"
import script from "./LinkList.vue?vue&type=script&lang=ts&"
export * from "./LinkList.vue?vue&type=script&lang=ts&"
import style0 from "./LinkList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports